import React, { FC, ReactElement } from 'react';

import { WizardPage } from 'buyside/components/presentation/Form/Wizard/Wizard';
import ProApplicationSubmission from './ProApplicationSubmission';
import { WizardContextProps } from 'interfaces/wizard/wizard';
import { applicationSubmissionSchema } from 'buyside/components/presentation/UserApplication/Helpers/validations';

export type PASCProps = {
  isLoading: boolean;
  isRobot: boolean;
};

const ProApplicationSubmissionContainer: FC<PASCProps & {
  validationSchema: typeof applicationSubmissionSchema;
}> = ({ validationSchema, isLoading, isRobot }): ReactElement => (
  <WizardPage validationSchema={validationSchema}>
    {({ values, touched, errors }: WizardContextProps): ReactElement => {
      return (
        <ProApplicationSubmission
          errors={errors}
          isLoading={Boolean(isLoading)}
          isRobot={Boolean(isRobot)}
          touched={touched}
          values={values}
        />
      );
    }}
  </WizardPage>
);

export default ProApplicationSubmissionContainer;
